import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChatBubble7: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChatBubble7"><Path d="M12 21C17.2467 21 21.5 16.9706 21.5 12C21.5 7.02944 17.2467 3 12 3C6.75329 3 2.5 7.02944 2.5 12C2.5 14.0519 3.22482 15.9434 4.44513 17.4573C4.2522 18.4858 3.93389 19.4823 3.55556 20.4706C4.87683 20.3889 6.12035 20.1802 7.32547 19.8369C8.7056 20.5773 10.3007 21 12 21Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconChatBubble7;
